module.exports = __webpack_public_path__ + "img/sejong_thumbnail.feb455a1.jpg";